
// api.js
import { jwtDecode } from 'jwt-decode';



// export const API_BASE_URL = 'http://127.0.0.1:5000';
// export const API_BASE_URL_WEBSOCKET = 'http://127.0.0.1:8080';

// export const API_BASE_URL = 'http://47.108.70.213:5000';
// export const API_BASE_URL_WEBSOCKET = 'http://47.108.70.213:8080';
export const API_BASE_URL = 'https://www.hiradio.cn';
export const API_BASE_URL_WEBSOCKET = 'wss://www.hiradio.cn/ws';




export const isTokenValid = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (err) {
    return false;
  }
};


export const hasGBSystemAccess = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    return decoded.isAbleforGBsystem === 'yes';
  } catch (err) {
    return false;
  }
};

export const getUserPublicId = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.userId || null;
  } catch (err) {
    return null;
  }
};

